/**
 * @file   src\mobile\components\createWantAd\OtherNiceToHaves.js
 * @brief  This file is responsible for nice to haves section subcomponent
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const OtherNiceToHaves = (props) => {
  const { others, handleItemClick, itemArray } = props;
  return (
    <NiceToHaveHelper
      list={others}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default OtherNiceToHaves;
